const configKey = "matpower:/data/config";

const ConfigStore = {
  data: {
    config: {
      manual: "html",
      debounce: 1000,
      graph: "2D",
      graphView: "initial",
      busNumbers: true,
      deviceLabels: true,
      branchFlows: "active",
      positions: {},
      transform: null,
      outputTab: ""
    }
  },
  methods: {
    loadConfig() {
      let data = localStorage.getItem(configKey);
      if (data) {
        ConfigStore.methods.setConfig(JSON.parse(data));
      }
    },
    saveConfig() {
      let data = JSON.stringify(ConfigStore.methods.getConfig());
      if (data) {
        localStorage.setItem(configKey, data);
      }
    },

    getConfig() {
      return ConfigStore.data.config;
    },
    setConfig(config) {
      ConfigStore.data.config = config;
    },

    getManual() {
      return ConfigStore.methods.getConfig().manual;
    },
    setManual(manual) {
      ConfigStore.methods.getConfig().manual = manual;
    },

    getDebounce() {
      return ConfigStore.methods.getConfig().debounce;
    },
    setDebounce(debounce) {
      ConfigStore.methods.getConfig().debounce = debounce;
    },

    getPositions() {
      return ConfigStore.methods.getConfig().positions;
    },
    setPositions(positions) {
      ConfigStore.methods.getConfig().positions = positions;
    },
    deletePositions() {
      ConfigStore.methods.getConfig().positions = {};
    },

    setTransform(t) {
      if (!isNaN(t.x) && !isNaN(t.y) && !isNaN(t.k)) {
        ConfigStore.methods.getConfig().transform = t;
      }
    },
    getTransform() {
      return ConfigStore.methods.getConfig().transform;
    },
    deleteTransform() {
      ConfigStore.methods.getConfig().transform = null;
    }
  }
};

export default ConfigStore;
